// extracted by mini-css-extract-plugin
export default {"table":"orderHistroy_table__oXAiN","icons":"orderHistroy_icons__nqo+1","pending":"orderHistroy_pending__Kciht","delivered":"orderHistroy_delivered__ev88n"};